import {
    SALESLOFT_CADENCE_VISIBILITY,
    type SalesloftCadenceVisibility,
} from "app/pages/sales-intelligence/modules/salesloft/constants/salesloftConstants";

export type CadenceSegment = "all" | "private" | "shared";

const SEGMENT_VISIBILITY: Record<CadenceSegment, SalesloftCadenceVisibility> = {
    all: SALESLOFT_CADENCE_VISIBILITY.all,
    private: SALESLOFT_CADENCE_VISIBILITY.private,
    shared: SALESLOFT_CADENCE_VISIBILITY.shared,
};

export const getCadenceVisibility = (segment: CadenceSegment): SalesloftCadenceVisibility =>
    SEGMENT_VISIBILITY[segment];
